import { render } from "./questionsList.vue?vue&type=template&id=bbf50082&scoped=true"
import script from "./questionsList.vue?vue&type=script&lang=js"
export * from "./questionsList.vue?vue&type=script&lang=js"

import "./questionsList.vue?vue&type=style&index=0&id=bbf50082&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf50082"]])

export default __exports__